const FabricationType = `
  id
  description
  category
`;

export default FabricationType;
